import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Modal,   } from 'antd';
import { EditOutlined } from '@ant-design/icons' ;

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			class: '',
			academic_year: '',
			subject: '',
			timetable_id: '',
			teacher: [],
			class_list: [],
			timetable_list: [],
			day_list: [],
			staff_list: [],
			tab: 'Monday',
			loading: false,
			mobile_child: false,
		}
		this.change_class = this.change_class.bind(this);
		this.change_year = this.change_year.bind(this);
		this.change_teacher = this.change_teacher.bind(this);
		this.updatetable = this.updatetable.bind(this);
	}
	
	
	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData()
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
					var storedArray = JSON.parse(localStorage.getItem("schoolData"));
					var school_id = storedArray['data'][0]['school_id'];
					var user_id = storedArray['data'][0]['user_id'];
					var day = this.state.tab;
					var eclass = this.state.class;
					var academic_year = this.state.academic_year;
				var app = {school_id : school_id,user_id:user_id,day:day,class:eclass,academic_year:academic_year}
					getData('erp/view_staff',app).then((result) => {
						let responseJson = result;
						if(responseJson.data){
							if(result['status'] == 200){
								this.setState({
									staff_list: result['data'],
									
								});
							}else{
								this.setState({
									staff_list: [],
									
								});
							}
						}
					});
					}
					
  }
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	  
	handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			setTimeout(() => {
				this.checkData();
			}, 20);		
			
	} 
	  
	change_class(event){
         this.setState({class: event,});
		 		var storedArray = JSON.parse(localStorage.getItem("schoolData"));
				var school_id = storedArray['data'][0]['school_id'];
				var user_id = storedArray['data'][0]['user_id'];
					
				var app = {school_id : school_id,user_id:user_id,academic_year:this.state.academic_year,teacher_id:event}
				getData('timetable/review_teacher_timetable',app).then((result) => {
					let responseJson = result;
					if(responseJson.data){
						if(result['status'] == 200){
							this.setState({
								day_list: result['data'],
							});
						}else{
							this.setState({
								day_list: [],
								
							});
						}
					}
				});
    }
		
	change_year(event){
         this.setState({academic_year: event});
     }	
	 
	change_teacher(event){
         this.setState({teacher: event});
     }
	 
	updatetable=(e)=>{
			var app = {
						timetable_id : this.state.timetable_id,
						teacher : this.state.teacher,
						subject : this.state.subject,
					  }
					this.setState({loading: true});  
					getData('Timetable/update_teacher_subject',app).then((result) => {
						let responseJson = result;
						
							if(result['status'] == 200){
								message.config({ top: 150});
								message.success('Timetable Updated',2);
								this.setState({
									timetable_id: '',
									teacher: [],
									subject: '',
									visible: false,
									loading: false,
									mobile_child: false,
									
								});
								setTimeout(() => {
									this.checkData();
								}, 20);	
								
							}else{
								this.setState({loading: false,mobile_child: false}); 
								message.config({ top: 150});
								message.error('Something went wrong',2);
							}
						
					});
				
			
	} 

	showDrawer = (id,timing,subject,class_o) => {
		this.setState({
		  mobile_child: true,
		  modal_id: id,
		  timing: timing,
		  subject: subject,
		  class: class_o,
		  topic: '',	
		  teaching_aid: '',
		  procedure: '',
		});
		var app = {user_id : this.state.user_id,id:id,school_id: this.state.school_id}
		getData('Timetable/get_timetable_report',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						topic: result['data'][0]['topic'],
						teaching_aid: result['data'][0]['teaching_aid'],
						procedure: result['data'][0]['methodology'],
					});
				}else{
					this.setState({
						topic: '',
						teaching_aid: '',
						procedure: '',
					});
				}
			}
		});

	  };
	 
	onClose = () => {
		this.setState({
		  mobile_child: false,
		});
	  }; 


	showModal = (id,timing,subject,class_o) => {
		this.setState({
		  visible: true,
		  modal_id: id,
		  timing: timing,
		  subject: subject,
		  class: class_o,
		  topic: '',	
		  teaching_aid: '',
		  procedure: '',
		});
		
		var app = {user_id : this.state.user_id,id:id,school_id: this.state.school_id}
		getData('Timetable/get_timetable_report',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						topic: result['data'][0]['topic'],
						teaching_aid: result['data'][0]['teaching_aid'],
						procedure: result['data'][0]['methodology'],
					});
				}else{
					this.setState({
						topic: '',
						teaching_aid: '',
						procedure: '',
					});
				}
			}
		});
	  };

	  handleOk = e => {
		console.log(e);
		this.setState({
		  visible: false,
		});
	  };

	  handleCancel = e => {
		console.log(e);
		this.setState({
		  visible: false,
		});
	  };

	 handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });		
	 }

	 handleSubmit=(e)=>{
		e.preventDefault();
		if(localStorage.getItem('schoolData')){
		this.setState({ loading: true });
		
		var app = {			
			user_id        : this.state.user_id,
			school_id      : this.state.school_id,
			period_id      : this.state.modal_id,
			topic          : this.state.topic,
			teaching_aid   : this.state.teaching_aid,
			procedure      : this.state.procedure,
		}
		
		getData('Timetable/add_report_timetable',app).then((result) => {
			if(result.status==400){
				message.config({ top: 150});
				message.error(result.error_msg,2);
				this.setState({ loading: false });
			}
			else if(result.status==200){
				message.config({ top: 150});
				message.success('Review Teacher Timetable Updated',2);
				this.setState({ loading: false,visible: false,mobile_child: false, });
				setTimeout(() => {
					this.checkData();
				}, 500);
			}
			else{
				this.setState({ loading: false });
			}
			
		});
	  }else{
		message.error('Please Login',2);	
		this.setState({ loading: false });
	  }

	}
	 
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
			
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Review Teacher Timetable</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                      <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/time-table">Time Table</a>
                           </li>
                           <li class="breadcrumb-item active">Review Teacher Timetable
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 	
           
		   <div class="col s12 m12 ex-padd view-Profile view-Profile-mobile"> 
            <div class="container staff-profile">
			   <div class="col s12 m12 mb-20  mh-500 no-padd">
                  <section class="section food no-padd">
					<div class="children mb-20 mh-40 time-table">
						
					<div class="desktop-view bg-white">
						<div class="">
								<div class="col m4 s12 mb-20 mt-20">
									
									<Select onChange={this.change_year} defaultValue="Select Academic Year">
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
									</Select>
								</div>
								<div class="col m4 s12 mb-20 mt-20">
										<Select onChange={this.change_class} defaultValue="Select Teacher">
											{this.state.staff_list.map((list)=> (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
										</Select>
								</div>									
							
						</div>

						<div class="dataTables_wrapper no-footer mh-500 ">
                          
                        <div class="clear"></div>
                        
						<div class="card-content mh-500 iq-card mt-80">
						{this.state.day_list.map((list)=>(
							<>
							<div class="col-md-12 mt-20 card-content mh-500 iq-card">
								{list.days.map((days)=> (
									<>
										<h6 class="mb-20 mt-20 color-red">{days.day}</h6>
										<table class="rev-tech-timetable">
											<thead>
												<tr>
													<td>Sr No.</td>
													<td>Time</td>
													<td>Subject</td>
													<td>Class-Division</td>
												</tr>
											</thead>
											<tbody>
											{days.data.map((main)=> (
												<tr>
													<td>{main.sr_no}</td>
													<td>{main.timing}</td>
													<td onClick={this.showModal.bind(this,main.id,main.timing,main.subject,main.class)}> <b><u>{main.subject}</u></b> </td>
													<td>{main.class}</td>
												</tr>
											))}	
											</tbody>
										</table>
									</>
								))}
							</div>
							</>
						))}
						</div>
	
            </div>	
						
						
						
						<div class="col m12 s12 mt-20">
							
						</div>		
					</div>
					<div class="mobile-view">
						<div class="">		
							<div class="row ">
								<div class="col m4 s6 mb-20 mt-20">
									
									<Select onChange={this.change_year} defaultValue="Select Academic Year">
										 <Select.Option value="2022-2023">2022-2023</Select.Option>	
										 <Select.Option value="2021-2022">2021-2022</Select.Option>	
										 <Select.Option value="2020-2021">2020-2021</Select.Option>
										 <Select.Option value="2019-2020">2019-2020</Select.Option>
										 <Select.Option value="2018-2019">2018-2019</Select.Option>
									</Select>
								</div>
								<div class="col m4 s6 mb-20 pl-0 mt-20">
										<Select onChange={this.change_class} defaultValue="Select Teacher">
											{this.state.staff_list.map((list)=> (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
										</Select>
								</div>									
							
							</div>	
						</div>	
							
											{this.state.day_list.map((list)=>(
							<>
							<div class="col-md-12 mt-20 card-content mh-500 iq-card">
								{list.days.map((days)=> (
									<>
										<h6 class="mb-20 mt-20 color-red ml-5">{days.day}</h6>
										{days.data.map((main)=> (
											<>
								<div class="children bg-blue tags iq-card2 flow-root" onClick={this.showDrawer.bind(this,main.id,main.timing,main.subject,main.class)}>
								<div class="col m12 s12 mb-10 bb pb-10 tag-div">
										<div class="col m10 s12 ">
											<span class="fw-4">Time :</span> {main.timing}<br/>
											<span class="fw-4">Subject :</span> {main.subject} <br/>
											<span class="fw-4">Class :</span> {main.class}<br/>
										</div>
										
								</div>
								</div>
								</>
								))}	
								</>
								))}

								
							</div>
							</>
						))}
											
											
							
							{(() => {  
												if (this.state.day_list.length =='0') {
													return (
														<p id="error" class="center mt-20" colspan="6">No Data Found</p>
													)
												}
											})()}	
						</div>	
						
					</div> 
					
					<Modal
						  title="Report Time Table"
						  visible={this.state.visible}
						  onOk={this.handleOk}
						  onCancel={this.handleCancel}
						  className="view-Profile"
						  width={1200}
						>
						<table class="rev-tech-timetable">
							<thead>
							<tr>
								<td>Lecture Time</td>
								<td>Subject</td>
								<td>Division</td>
								<td>Topics / Sub-Topics</td>
								<td>Teaching Aid</td>
								<td>Procedure / Methodology</td>
								<td>Submit</td>
							</tr>
							</thead>
							<tbody>
							<tr> 
							
								<td>{this.state.timing}</td>
								<td>{this.state.subject}</td>
								<td>{this.state.class}</td>
								<td><input type="text" name="topic" class="w-90per" value={this.state.topic} onChange={this.handleSizeChange}  /></td>
								<td><input type="text" name="teaching_aid" class="w-90per" value={this.state.teaching_aid} onChange={this.handleSizeChange}  /></td>
								<td><input type="text" name="procedure" class="w-90per" value={this.state.procedure} onChange={this.handleSizeChange}  /></td>
								<td><Button className="snd-btn mt-10"  onClick={this.handleSubmit} loading={this.state.loading} >Submit</Button></td>									
							</tr>
							</tbody>
						</table>
						
					</Modal>
					
					<Drawer
								  title="Report Time Table"
								  width="100%"
								  onClose={this.onClose}
								  visible={this.state.mobile_child}
								  bodyStyle={{ paddingBottom: 80 }}
								  className="select-child"
								>

								<div class="children bg-blue view-Profile attendance mt-10 row">
										<div class="col m6 s12 mb-20 dis-input">
												<label class="d-block">Lecture Time</label>
												<b>{this.state.timing}</b>
										</div>
										<div class="col m6 s12 mb-20 dis-input">
												<label class="d-block">Subject</label>
												<b>{this.state.subject}</b>
										</div>
										<div class="col m6 s12 mb-20 dis-input">
												<label class="d-block">Class</label>
												<b>{this.state.class}</b>
										</div>
										<div class="col m6 s12 mb-20 dis-input">
												<label>Topics / Sub-Topics</label>
												<input type="text" name="topic" class="w-90per" value={this.state.topic} onChange={this.handleSizeChange}  />
										</div>
										<div class="col m6 s12 mb-20 dis-input">
												<label>Teaching Aid</label>
												<input type="text" name="teaching_aid" class="w-90per" value={this.state.teaching_aid} onChange={this.handleSizeChange}  />
										</div>
										<div class="col m6 s12 mb-20 dis-input">
												<label>Procedure / Methodology</label>
												<input type="text" name="procedure" class="w-90per" value={this.state.procedure} onChange={this.handleSizeChange}  />
										</div>
										
									</div>
								
									<div className="fix-foter">
										 
										 <Button onClick={this.handleSubmit} loading={this.state.loading} type="primary">
											Done
										 </Button>
									</div>
								  
								</Drawer>
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
